import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { getPin } from "@/lib/api";
import Login from "@/pages/Login";
import Start from "@/pages/Start";
import Wizard from "@/pages/Wizard";
import Dashboard from "@/pages/Dashboard";
import CloseDetail from "@/pages/CloseDetail";
import AttachPhotos from "@/pages/AttachPhotos";
import TipLog from "@/pages/TipLog";
import Bridge from "@/pages/Bridge";
import Help from "@/pages/Help";
import GlobalCoach from "@/components/GlobalCoach";
import "@/App.css";

function Guard({ children }) {
  return getPin() ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Guard><Start /></Guard>} />
        <Route path="/close/:till/:mode" element={<Guard><Wizard /></Guard>} />
        <Route path="/dashboard" element={<Guard><Dashboard /></Guard>} />
        <Route path="/close-detail/:id" element={<Guard><CloseDetail /></Guard>} />
        <Route path="/attach-photos" element={<Guard><AttachPhotos /></Guard>} />
        <Route path="/tips" element={<Guard><TipLog /></Guard>} />
        <Route path="/bridge" element={<Guard><Bridge /></Guard>} />
        <Route path="/help" element={<Guard><Help /></Guard>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <GlobalCoach />
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}
